// Logout view for the d3-auth web app.
//
// Normally reached via redirect from `/oauth/<tenant>/logout` on the d3-auth
// API, but anyone can link here directly. This view's job is to clear the
// d3-auth web origin's localStorage tokens (the SSO session) — the API origin
// can't clear them itself because it's a different origin — and then hand
// back to the API, which validates `returnTo` and redirects to it. It never
// follows `returnTo` itself (#157); see lib/logout.js.

import { getBackendUrl } from '../../lib/backend.js';
import { BaseComponent } from '../../lib/base-component.js';
import { logoutContinueUrl } from '../../lib/logout.js';
import { html } from '../../vendor/lit.min.js';

const TOKEN_KEYS = ['d3auth_access_token', 'd3auth_refresh_token', 'd3auth_token_expiry'];

class LogoutView extends BaseComponent {
    async connectedCallback() {
        await super.connectedCallback();
        for (const key of TOKEN_KEYS) {
            try {
                localStorage.removeItem(key);
            } catch {
                // localStorage unavailable — best-effort
            }
        }
        window.location.replace(logoutContinueUrl(window.location.search, getBackendUrl()));
    }

    render() {
        return html`<p class="text-muted text-center mt-5">Signing out…</p>`;
    }
}

customElements.define('logout-view', LogoutView);
